import FontFaceObserver from 'fontfaceobserver';

export default () => {
	const $html = document.documentElement;
	const headingFont = $html.dataset.fontHeading || 'DMSans';
	const bodyFont = $html.dataset.fontBody || 'DMSans';

	const families = [...new Set([headingFont, bodyFont])];
	const observers = families.map(family => new FontFaceObserver(family).load());

	Promise.all(observers)
		.then(() => $html.classList.add('fonts-loaded'))
		.catch(() => $html.classList.add('fonts-failed'));
};
